import React, { FC } from 'react';
import s from './index.module.scss';
import label from './img/label.png';
import locales from '../../../content.json';

interface GuaranteeProps {
  discount?: boolean;
}

const Guarantee: FC<GuaranteeProps> = ({ discount }) => {
  return (
    <div className={`${s.guarantee} ${discount ? s.discount : ''}`}>
      <h3>
        {locales[window.userLang].payment_text_137}
      </h3>
      <p>
        {locales[window.userLang].payment_text_138}
      </p>
      <p dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_139}} />
      <img src={label} alt="label" />
    </div>
  );
};

export default Guarantee;